import { Link } from "react-router-dom";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { CONTACT, CREDIT } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-brand-black text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-36 md:py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img src="/logo-treffe-white.png" alt="treffe — Centro di Formazione 3F" className="h-12 w-auto mb-5" />
            <p className="text-white/60 text-sm max-w-sm leading-relaxed">
              Formazione e sicurezza sul lavoro, spiegate semplice e fatte bene:
              consulenza D.Lgs 81/08, certificazioni FGAS, bandi regionali e corsi BLS-D/AHA.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-brand-red mb-4">Dati aziendali</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li className="text-white/90 font-semibold">{CONTACT.owner}</li>
              <li><a href={`tel:${CONTACT.phone}`} className="hover:text-white">{CONTACT.phoneDisplay}</a></li>
              <li className="text-white/90 font-semibold pt-1">{CONTACT.owner2}</li>
              <li><a href={`tel:${CONTACT.phone2}`} className="hover:text-white">{CONTACT.phone2Display}</a></li>
              <li className="pt-1">{CONTACT.address}, {CONTACT.city}</li>
              <li><a href={`tel:${CONTACT.landline}`} className="hover:text-white">{CONTACT.landlineDisplay}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a></li>
              <li className="text-white/50 pt-1">P.IVA {CONTACT.piva}</li>
              <li className="text-white/50">C.F. {CONTACT.cf}</li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-brand-red mb-4">Seguici</div>
            <div className="flex gap-3">
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-11 h-11 flex items-center justify-center border border-white/20 hover:bg-brand-red hover:border-brand-red transition-colors">
                <FaInstagram size={18} />
              </a>
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-11 h-11 flex items-center justify-center border border-white/20 hover:bg-brand-red hover:border-brand-red transition-colors">
                <FaFacebookF size={16} />
              </a>
            </div>
          </div>
        </div>

        <a
          href={CREDIT.url}
          target="_blank"
          rel="noreferrer"
          data-testid="credit-footer-card"
          aria-label="Progettato e sviluppato da BC Next — visita bcnext.it"
          className="group mt-14 block border border-white/10 bg-white/[0.02] hover:bg-white/[0.045] transition-colors"
        >
          <div className="px-5 py-6 md:px-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="min-w-0">
              <div className="text-[11px] uppercase tracking-[0.26em] text-white/50">Un progetto di</div>
              <div className="font-heading text-2xl md:text-3xl font-bold text-white">BC Next</div>
              <p className="mt-1 text-sm text-white/60 max-w-md">Siti chiari, veloci e pensati per farsi contattare.</p>
            </div>
            <span className="inline-flex w-fit items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-semibold text-white/80 group-hover:text-white group-hover:border-brand-red transition-colors">
              bcnext.it <span aria-hidden="true">↗</span>
            </span>
          </div>
        </a>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs md:text-sm text-white/55">
          <span>© {new Date().getFullYear()} treffe — Centro di Formazione 3F. Tutti i diritti riservati. · <Link to="/privacy" className="hover:text-white underline" data-testid="footer-privacy-link">Privacy &amp; Cookie</Link></span>
          <span className="font-heading font-bold tracking-normal text-white/75">Formazione che crea esperienza · Frosinone</span>
        </div>
      </div>
    </footer>
  );
};
